import { defineComponent, openBlock, createBlock, unref, withCtx, createTextVNode } from 'vue';
import { Button } from '@ssml-editor/vue';
import dayjs from '../../../_virtual/dayjs.min.js';
import { CodeUtils } from '../code/code-utils.js';
import { FileUtils } from './file-utils.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "export-menu",
  props: {
    config: {},
    editor: {}
  },
  setup(__props) {
    function formatCodes(codes) {
      return codes.map((code) => {
        return CodeUtils.format(code);
      }).join("\n");
    }
    function menuClickHandler() {
      if (__props.editor) {
        const codes = __props.editor.serializeAndNormalize();
        const code = formatCodes(codes);
        const fileName = `ssml-raw-${dayjs().format("YYYY-MM-DDTHH:mm:ss")}.txt`;
        FileUtils.export(fileName, code);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Button), {
        "icon-class": "iconfont-ssml-editor icon-ssml-editor-daochu",
        onClick: menuClickHandler
      }, {
        default: withCtx(() => [
          createTextVNode("导出")
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=export-menu.vue.js.map
